import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface EventsAssignmentPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_EVENTS_ASSIGNMENT;
    id: string;
    attributes: {
      data: Array<{
        assignment_status: string;
        event_count: number;
        scheduled_hours: number;
      }>;
      aggregate: {
        total_scheduled_hours: InsightMetric;
      };
    };
  };
}

export const parseEventsAssignmentPayload = (
  payload: BaseInsightPayload
): EventsAssignmentPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_EVENTS_ASSIGNMENT,
    data.attributes,
    true,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      assignment_status: string;
      event_count: number;
      scheduled_hours: number;
    }>;
    aggregate: {
      total_scheduled_hours: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_EVENTS_ASSIGNMENT,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          total_scheduled_hours:
            typedAttributes.aggregate.total_scheduled_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
